import React, { useState, useEffect, useRef, useCallback } from "react";
import clsx from "clsx";
import { ProductSearch, getAllBrandProduct } from '../generatedRequest/product';
import MasterCustomTooltip from "../utils/CustomStyleComponent/MasterModelTooltip";
import AttributeAccordion from "./AttributeAccordion";
import "./indicator.css";
import CustomArrow from "../utils/CustomStyleComponent/ArrowComponent";
import CustomTooltip1 from "../utils/CustomStyleComponent/TooltipNewComponent";
import { getProductGroupByBrand, getProductByProductGroup, getProductByPowerGroup } from "../generatedRequest/master";
import Multiselect from "multiselect-react-dropdown";
import CustomCrossButton from "../utils/CustomStyleComponent/CrossButtonComponent";
import MasterModelSelector from "./MasterModelSelector";
import { Padding } from "maplibre-gl";
import debounce from "lodash/debounce";
import { offset } from "@popperjs/core";

const AddMasterForm = ({
    formik,
    onFormDataChange,
}: {
    formik: any;
    onFormDataChange?: (data: any) => void;
}) => {
    const [perPageRecords, setPerPageRecords] = useState(100);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [keyword, setKeyword] = useState("");
    const [selectedProductsId, setSelectedProductsId] = useState<string[]>([]);
    const [selectedProducts, setSelectedProducts] = useState<{ id: number;[key: string]: any }[]>([]);
    const [attributeFilters, setAttributeFilters] = useState<{ [key: string]: string[] }>({});
    const [modelGroupSearchTerm, setModelGroupSearchTerm] = useState("");
    const [uniqueAcAdapterPowerValues, setUniqueAcAdapterPowerValues] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [masterModel, setMasterModel] = useState<{
        id: number | null;
        displayName: string | null;
        productName: string | null;
        modelNumber: string | null;
        attributes: [] | null;
    }>({
        id: null,
        displayName: null,
        productName: null,
        modelNumber: null,
        attributes: null,
    });
    const style = {
        multiSelectContainer: {
            minheight: "44px",
            border: "1px solid var(--bs-gray-100)",
        },
        searchBox: {
            minheight: "44px",
            fontWeight: "500",
            minwidth: "40px",
            maxwidth: "40px",
            height: "44px",
            display: "flex",
            alignItems: "center",
        },
        chips: {
            marginBottom: "0",
        },
    };

    const [uniqueAttributes, setUniqueAttributes] = useState<string[]>([]);
    const [selectedAttributes, setSelectedAttributes] = useState<string[]>([]);
    const [productsToRemove, setProductsToRemove] = useState<string[]>([]);
    const [productInfo, setProductInfo] = useState<any[]>([]);
    const searchContainerRef = useRef<HTMLDivElement | null>(null);
    const [allBrand, setAllBrand] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState("");
    const [selectedFamilyGroup, setSelectedFamilyGroup] = useState("");
    const [allProductGroups, setAllProductGroups] = useState<any[]>([]);
    const [selectedProductGroup, setSelectedProductGroup] = useState<any>({});
    const [totalProductShown, setTotalProductShown] = useState<any>(0);
    const [selectedValue, setSelectedValue] = useState('');
    const [productSearchTerm, setProductSearchTerm] = useState("");
    const [allProductGroupsWithCount, setAllProductGroupsWithCount] = useState<any[]>([]);
    const [availablePowerValues, setAvailablePowerValues] = useState<string[]>([]);
    const [selectedPowerValues, setSelectedPowerValues] = useState<string[]>([]);
    /* const allProductGroupsWithCount = allProductGroups.map((item) => ({
        ...item,
        labelWithCount: `${item.label} (${item.count})`
    })); */

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (
                searchContainerRef.current &&
                searchContainerRef.current.contains &&
                !searchContainerRef.current.contains(event.target)
            ) {
                setShowSuggestions(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleMasterModelChange = (model: any) => {

        setMasterModel(model);
    };

    const handleFormDataChange = (data: { keyword: string, masterModel: any }) => {
        // console.log("Received data from child:", data);
        formik.setFieldValue("keyword", data.keyword || '');
        formik.setFieldValue("masterModel", data.masterModel || {});
    };
    useEffect(() => {

        if (selectedProducts.length === 0) {
            setUniqueAttributes([]);
            return;
        }

        // Get products that have attributes
        const productsWithAttributes = selectedProducts.filter(product =>
            product.attributes &&
            Array.isArray(product.attributes) &&
            product.attributes.length > 0
        );

        if (productsWithAttributes.length === 0) {
            setUniqueAttributes([]);
            return;
        }
        const allAttributeNames = productsWithAttributes
            .flatMap(product =>
                product.attributes.map((attr: any) => {
                    if (typeof attr === 'string') {
                        return attr;
                    }
                    if (typeof attr === 'object' && attr.attributeName) {
                        return attr.attributeName;
                    }
                    return null;
                })
            )
            .filter(name => name !== null && name !== undefined && name !== '');

        // console.log("All attribute names:", allAttributeNames);
        const uniqueAttributeNames = Array.from(new Set(allAttributeNames));
        setUniqueAttributes(uniqueAttributeNames);

        //console.log("Unique attributes:", uniqueAttributeNames);
    }, [selectedProducts]);

    const handleAttributeSelection = (attributeName: string) => {
        setSelectedAttributes(prev => {
            if (prev.includes(attributeName)) {
                // Remove if already selected
                return prev.filter(attr => attr !== attributeName);
            } else {
                // Add if not selected
                return [...prev, attributeName];
            }
        });
    };

    const fetchProductGroups = useCallback(
        debounce(async (searchTerm: string) => {
            setIsLoading(true);
            try {
                // Replace 'selectedBrand' with your actual brand state/variable
                const response = await getProductGroupByBrand(selectedBrand, searchTerm);
                if (response.data.status) {
                    const allProductGroups = response.data.data.map((item: any) => ({
                        ...item,
                        labelWithCount: `${item.label} (${item.count})`
                    }));
                    setAllProductGroupsWithCount(allProductGroups);
                } else {
                    setAllProductGroupsWithCount([]);
                }
            } catch {
                setAllProductGroupsWithCount([]);
            }
            setIsLoading(false);
        }, 600),
        [selectedBrand]
    );

    useEffect(() => {
        if (modelGroupSearchTerm.length > 0) {
            fetchProductGroups(modelGroupSearchTerm);
        }
    }, [modelGroupSearchTerm, fetchProductGroups]);

    const handleProductRemovalSelection = (productId: string) => {
        setProductsToRemove(prev => {
            if (prev.includes(productId)) {
                return prev.filter(id => id !== productId);
            } else {
                return [...prev, productId];
            }
        });
    };

    // Function to handle "Select All" for removal
    const handleSelectAllForRemoval = (checked: boolean) => {
        if (checked) {
            // Get only filtered products IDs (currently visible products)
            const filteredProductIds = getFilteredProducts().map(product =>
                product.id?.toString() || `product-${selectedProducts.indexOf(product)}`
            );
            // Add filtered product IDs to existing selected products (don't replace all)
            setProductsToRemove(prev => Array.from(new Set([...prev, ...filteredProductIds])));
        } else {
            // Remove only filtered product IDs from selection
            const filteredProductIds = getFilteredProducts().map(product =>
                product.id?.toString() || `product-${selectedProducts.indexOf(product)}`
            );
            setProductsToRemove(prev => prev.filter(id => !filteredProductIds.includes(id)));
        }
    };

    // Function to check if a product is selected for removal
    const isProductSelectedForRemoval = (productId: string) => {
        return productsToRemove.includes(productId);
    };

    // Function to check if all products are selected for removal
    const areAllProductsSelectedForRemoval = () => {
        const filteredProducts = getFilteredProducts();
        if (filteredProducts.length === 0) return false;

        const filteredProductIds = filteredProducts.map(product =>
            product.id?.toString() || `product-${selectedProducts.indexOf(product)}`
        );
        return filteredProductIds.every(id => productsToRemove.includes(id));

    };

    const getSelectedFilteredProductsCount = () => {
        const filteredProducts = getFilteredProducts();
        const filteredProductIds = filteredProducts.map(product =>
            product.id?.toString() || `product-${selectedProducts.indexOf(product)}`
        );
        return filteredProductIds.filter(id => productsToRemove.includes(id)).length;
    };
    // Function to remove selected products
    const handleRemoveSelectedProducts = () => {
        setSelectedProducts(prev =>
            prev.filter(product => {
                const productId = product.id?.toString() || `product-${prev.indexOf(product)}`;
                return !productsToRemove.includes(productId);
            })
        );
        setProductsToRemove([]);

    };

    useEffect(() => {
        if (selectedProducts.length == 0) {
            setSelectedAttributes([])
        }

    }, [selectedProducts]);


    const handleBrandFilter = async (data: any) => {

        if (data.length === 0) {
            setAllProductGroups([]);
            setSelectedProducts([]);
            return;
        }
        //setIsLoading(true);
        setSelectedBrand(data[0].brandName);
        /* const response = await getProductGroupByBrand(data[0].brandName);
        if (response.data.status) {
            setAllProductGroups(response.data.data);
            setIsLoading(false);
        } else {
            console.error("Something went wrong");
            setIsLoading(false);
        } */

    }

    const handleProductFamilyFilter = async (data: any, offset = 0, perPageRecords = 100) => {
        setIsLoading(true);
        if (offset === 0 && data.length === 0) {
            setAllProductGroups([]);
            setSelectedProducts([]);
            return;
        }

        if (offset === 0) {
            setSelectedProducts([]);
        }
        setTotalProductShown(offset + perPageRecords);
        const selectedGroup = data[0];
        selectedGroup.shownProducts = offset + perPageRecords
        setSelectedProductGroup(selectedGroup);

        const response = await getProductByProductGroup(selectedBrand, data[0].label, offset, perPageRecords);
        if (response.data.status) {
            //setSelectedItems(response.data.data);
            console.log(response.data.data)
            // const productData = response.data.data.products;
            const uniqueValue = response.data.data.uniqueAcAdapterPowerValues
            // console.log(productData, "product")
            setUniqueAcAdapterPowerValues(uniqueValue || []);


            // const newProducts = productData.map((item: any) => {
            //     const productId = item.id || item._id || `product-${Date.now()}`;
            //     return { ...item, id: productId };
            // });


            // setSelectedProducts(prev => [...prev, ...newProducts]);
            setIsLoading(false);
        } else {
            console.error("Something went wrong");
            setIsLoading(false);
        }
        //onBrandFilterChange(data)
    }

    const handleAddPowerGroups = async (brand: string, powerValues: string[], offset = 0, perPageRecords = 100) => {
        setIsLoading(true);

        if (!brand || powerValues.length === 0) {
            console.error("Brand and power values are required");
            setIsLoading(false);
            return;
        }

        try {
            console.log("Calling API with:", { brand, powerValues, offset, perPageRecords });

            const response = await getProductByPowerGroup(
                brand,
                powerValues,
                offset,
                perPageRecords
            );

            console.log("API Response:", response);
            if (response.data.status) {
                //setSelectedItems(response.data.data);
                console.log(response.data.data)
                const productData = response.data.data;
                // const uniqueValue = response.data.data.uniqueAcAdapterPowerValues
                console.log(productData, "product")



                const newProducts = productData.map((item: any) => {
                    const productId = item.id || item._id || `product-${Date.now()}`;
                    return { ...item, id: productId };
                });
                if (offset === 0) {
                    setSelectedProducts(newProducts);
                } else {
                    setSelectedProducts(prev => [...prev, ...newProducts]);
                }

                // setSelectedProducts(prev => [...prev, ...newProducts]);
                setIsLoading(false);
            } else {
                console.error("Something went wrong");
                setIsLoading(false);
            }
        } catch (error) {
            console.error("API call failed:", error);
            setIsLoading(false);
        }
    };



    const handleSelectChange = (index: any, value: any) => {
        setSelectedValue((prev: any) => ({
            ...prev,
            [index]: value,
        }));
    };

    useEffect(() => {
        const fetchAllBrand = async () => {
            try {
                const response = await getAllBrandProduct();
                // console.log(response, "response brand")
                if (response.data.status) {
                    setAllBrand(response.data.data);
                } else {
                    console.error("Something went wrong");
                }
            } catch (error) {
                console.error("Network Error");
            }
        };

        fetchAllBrand();
    }, []);

    // final save to formik data 
    useEffect(() => {
        // Get filtered products first (jo products currently visible hain after filtering)
        const filteredProducts = getFilteredProducts();

        // From filtered products, get only those that are selected (in productsToRemove)
        const finalProductsToSave = filteredProducts.filter(product => {
            const productId = product.id?.toString() || `product-${selectedProducts.indexOf(product)}`;
            return productsToRemove.includes(productId); // Only selected products from filtered results
        });

        const filteredProductsData = finalProductsToSave.map((product, productIndex) => {
            const filteredProduct = {
                _id: product._id,
                displayName: product.displayName || '',
                productName: product.productName || '',
                modelNumber: product.modelNumber || '',
                attributes: product.attributes || []
            };
            return filteredProduct;
        });

        // Set filtered data to formik - only filtered + selected products
        setProductInfo(filteredProductsData);

        // Also update formik with the products that will actually be saved
        formik.setFieldValue('productInfo', filteredProductsData);
        formik.setFieldValue('selectedProducts', finalProductsToSave);

        // console.log("Filtered products count:", filteredProducts.length);
        // console.log("Selected from filtered:", finalProductsToSave.length);
        // console.log("Will be saved:", filteredProductsData.length);

    }, [selectedProducts, productsToRemove, selectedAttributes, attributeFilters, productSearchTerm]);

    useEffect(() => {
        // Get filtered products first
        const filteredProducts = getFilteredProducts();

        // From filtered products, get only selected ones
        const filteredSelectedIds = filteredProducts
            .filter(product => {
                const productId = product.id?.toString() || `product-${selectedProducts.indexOf(product)}`;
                return productsToRemove.includes(productId);
            })
            .map(product => product.id?.toString() || `product-${selectedProducts.indexOf(product)}`);

        formik.setFieldValue("selectedChildModels", filteredSelectedIds);

        // console.log("Final selected IDs for saving:", filteredSelectedIds.length);
    }, [productsToRemove, selectedProducts, selectedAttributes, attributeFilters, productSearchTerm])

    useEffect(() => {
        // Update formik values when selectedProductsId changes
        formik.setFieldValue("selectedChildModels", productsToRemove);

        //console.log("Selected Products ID:", formik.values.selectedChildModels.length);
    }, [productsToRemove,]);


    // formik code 

    // filter functionality

    useEffect(() => {
        // Check if any filter has values that no longer exist in current products
        const updatedFilters = { ...attributeFilters };
        let filtersChanged = false;

        Object.keys(attributeFilters).forEach(attributeName => {
            const currentFilterValue = attributeFilters[attributeName];
            if (Array.isArray(currentFilterValue) && currentFilterValue.length > 0) {
                const uniqueValues = getUniqueValuesForAttribute(attributeName);

                // Remove filter values that no longer exist in available values
                const validFilterValues = currentFilterValue.filter((value: any) => uniqueValues.includes(value));
                if (validFilterValues.length !== currentFilterValue.length) {
                    updatedFilters[attributeName] = validFilterValues;
                    filtersChanged = true;
                }
            }
        });

        if (filtersChanged) {
            setAttributeFilters(updatedFilters);
        }
    }, [selectedProducts]); // This will run whenever selectedProducts changes

    // Updated function to get unique values for each attribute including blank values
    const getUniqueValuesForAttribute = (attributeName: any) => {
        const values = new Set();

        selectedProducts.forEach(product => {
            const attributeValue = product.attributes?.find((attr: any) => {
                if (typeof attr === 'string') {
                    return attr === attributeName;
                }
                if (typeof attr === 'object' && attr.attributeName) {
                    return attr.attributeName === attributeName;
                }
                return false;
            });

            let displayValue = '-';
            if (attributeValue) {
                if (typeof attributeValue === 'string') {
                    displayValue = attributeValue;
                } else if (attributeValue.value) {
                    displayValue = attributeValue.value;
                }
            }

            // Add all values including blank/dash values
            values.add(displayValue);
        });

        // Convert to array and sort, with blank values at top
        const valuesArray = Array.from(values).sort((a: any, b: any) => {
            // Put blank/dash values at the top
            if (a === '-' && b !== '-') return -1;
            if (b === '-' && a !== '-') return 1;
            return a.localeCompare(b);
        });

        return valuesArray;
    };

    //  Reset all filters when products change significantly
    const resetFilters = () => {
        setAttributeFilters({});
    };

    const handleRemoveSelectedProductsWithFilterReset = () => {
        handleRemoveSelectedProducts();

        setTimeout(() => {
            resetFilters();
        }, 100);
    };

    // Updated function to handle filter change
    const handleFilterChange = (attributeName: any, selectedValues: any[]) => {
        setAttributeFilters(prev => ({
            ...prev,
            [attributeName]: selectedValues.map(item => item.value)
        }));
    };
    const handleProductSearch = (searchTerm: string) => {
        setProductSearchTerm(searchTerm);
    };

    // Updated function to filter products based on selected filters including blank values
    const getFilteredProducts = () => {
        return selectedProducts.filter(product => {
            const matchesSearch = !productSearchTerm ||
                (product.displayName && product.displayName.toLowerCase().includes(productSearchTerm.toLowerCase())) ||
                (product.productName && product.productName.toLowerCase().includes(productSearchTerm.toLowerCase())) ||
                (product.modelNumber && product.modelNumber.toLowerCase().includes(productSearchTerm.toLowerCase())) ||
                (product.name && product.name.toLowerCase().includes(productSearchTerm.toLowerCase()));
            if (!matchesSearch) return false;
            return selectedAttributes.every(attributeName => {
                const filterValues = attributeFilters[attributeName] || [];

                // If no filter is set for this attribute, include the product
                if (filterValues.length === 0) {
                    return true;
                }

                // Find the attribute value for this product
                const attributeValue = product.attributes?.find((attr: any) => {
                    if (typeof attr === 'string') {
                        return attr === attributeName;
                    }
                    if (typeof attr === 'object' && attr.attributeName) {
                        return attr.attributeName === attributeName;
                    }
                    return false;
                });

                let displayValue = '-';
                if (attributeValue) {
                    if (typeof attributeValue === 'string') {
                        displayValue = attributeValue;
                    } else if (attributeValue.value) {
                        displayValue = attributeValue.value;
                    }
                }

                // Check if the display value matches any of the selected filters
                return filterValues.includes(displayValue);
            });
        });
    };

    useEffect(() => {
        // Check if any filter has values that no longer exist in current products
        const updatedFilters = { ...attributeFilters };
        let filtersChanged = false;

        Object.keys(attributeFilters).forEach(attributeName => {
            const currentFilterValues = attributeFilters[attributeName] || [];
            if (currentFilterValues.length > 0) {
                const uniqueValues = getUniqueValuesForAttribute(attributeName);

                // Remove filter values that no longer exist
                const validFilterValues = currentFilterValues.filter((value: any) => uniqueValues.includes(value));
                if (validFilterValues.length !== currentFilterValues.length) {
                    updatedFilters[attributeName] = validFilterValues;
                    filtersChanged = true;
                }
            }
        });

        if (filtersChanged) {
            setAttributeFilters(updatedFilters);
        }
    }, [selectedProducts]);
    useEffect(() => {
        // Update formik with selected power values as powerGroups
        formik.setFieldValue("powerGroups", selectedPowerValues);

        console.log("Selected Power Values for formik:", selectedPowerValues);
    }, [selectedPowerValues]);


    useEffect(() => {
        formik.setFieldValue("selectedAttributes", selectedAttributes);
        //formik.setFieldValue('productInfo', productInfo)
        formik.setFieldValue('brandName', selectedBrand)
        formik.setFieldValue('productFamily', selectedProductGroup?.label)
        formik.setFieldValue('selectedProductGroup', selectedProductGroup)
        formik.setFieldValue("powerGroups", selectedPowerValues);

    }, [keyword, masterModel, selectedAttributes, productInfo, selectedPowerValues]);
    const filterMultiSelectStyle = {
        multiSelectContainer: {
            border: "1px solid var(--bs-gray-100)",
        },
        searchBox: {
            minHeight: "40px",
            fontWeight: "400",
            height: "28px",
            maxHeight: "30px",
            display: "flex",
            alignItems: "center",
            minWidth: "100px",
            // maxWidth: "250px",
            fontSize: "12px",
            Padding: "0px",
            // overflowX: "auto",
            // overflowY: "hidden",
        },
        chips: {
            marginBottom: "0",
            height: "28px"
        },
    };

    const handleEditProduct = (productId: string | number) => {
        const url = process.env.REACT_APP_BASE_URL + `/product/edit?q=${productId}`;
        window.open(url, '_blank');
    };

    const handleSelectPowerValue = (powerValue: string) => {
        setSelectedPowerValues(prev => [...prev, powerValue]);
        setAvailablePowerValues(prev => prev.filter(value => value !== powerValue));
    };

    const handleRemovePowerValue = (powerValue: string) => {
        setAvailablePowerValues(prev => [...prev, powerValue]);
        setSelectedPowerValues(prev => prev.filter(value => value !== powerValue));
    };

    // Update your existing useEffect where you set uniqueAcAdapterPowerValues:
    useEffect(() => {
        if (uniqueAcAdapterPowerValues.length > 0) {
            setAvailablePowerValues(uniqueAcAdapterPowerValues);
            setSelectedPowerValues([]);
        }
    }, [uniqueAcAdapterPowerValues]);

    // Add this function after your state declarations
    const calculateTotalCountFromPowerValues = (selectedPowerValues: string[]) => {
        if (!selectedPowerValues || selectedPowerValues.length === 0) {
            return 0;
        }

        let totalCount = 0;

        selectedPowerValues.forEach((powerValue: any) => {
            const brackets = powerValue.match(/\(([^)]+)\)/g);

            if (brackets && brackets.length > 0) {
                const lastBracket = brackets[brackets.length - 1];
                const numberStr = lastBracket.replace(/[()]/g, '');
                const number = parseInt(numberStr, 10);
                if (!isNaN(number)) {
                    totalCount += number;
                }
            }
        });

        return totalCount;
    };

    const getTotalPowerValuesCount = () => {
        return calculateTotalCountFromPowerValues(selectedPowerValues);
    };
    const totalAvailableCount = getTotalPowerValuesCount() || selectedProductGroup?.count || 0;
    return (
        <>

            {isLoading && (
                <div className="overlay-loader">
                    <div className="loader-container">
                        <div className="spinner"></div>
                        <div className="loader-text">Searching products...</div>
                    </div>
                </div>
            )}
            <div className="pb-0" style={{ marginBottom: "30px", maxWidth: "100%", minWidth: "100%" }}>
                <div className=" px-0  m-0 gap-2 w-100" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div className="row w-100">
                        <div className="col-md-12 p-5 w-100">

                            <MasterModelSelector
                                onMasterModelChange={handleMasterModelChange}
                                formik={formik}
                                onFormDataChange={handleFormDataChange}
                                data={{}}
                                showSyncButton={false}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="card p-5 mt-5">

                <div className="row mb-4">
                    <div className="col-md-6">
                        <label className="form-label fs-6 fw-bolder text-dark required">
                            Select Brand
                        </label>
                        <Multiselect
                            options={allBrand}
                            displayValue="brandName"
                            placeholder="Select Brand"
                            hidePlaceholder={true}
                            selectionLimit={1}
                            style={style}
                            showArrow={true}
                            customArrow={<CustomArrow />}
                            customCloseIcon={<CustomCrossButton />}
                            avoidHighlightFirstOption={true}
                            onSelect={handleBrandFilter}
                            onRemove={handleBrandFilter}
                            selectedValueDecorator={(value: string, option: any) => {
                                return (
                                    <CustomTooltip1 value={value} truncated={true} option={option} />
                                );
                            }}
                        />
                        <small className="text-muted">Select brand to filter product groups</small>
                    </div>

                    <div className="col-md-6">
                        <div className="d-flex align-items-center justify-content-start">
                            <label className="form-label fs-6 fw-bolder text-dark required">
                                Search Products Family Group To Select The Child Model
                            </label>
                        </div>

                        <Multiselect
                            options={allProductGroupsWithCount}
                            displayValue="labelWithCount"
                            selectionLimit={1}
                            showArrow={true}
                            placeholder="Select Model Group"
                            //onSelect={(data) => handleProductFamilyFilter(data, 0)}
                            onSelect={(data) => handleProductFamilyFilter(data, 0)}
                            onSearch={fetchProductGroups}
                        />
                    </div>
                    {uniqueAcAdapterPowerValues.length > 0 && (
                        <div className="col-md-12 mb-4 mt-2">
                            <div className="row">
                                {/* Left side - Available Power Values (50%) */}
                                <div className="col-md-12">
                                    <div className="d-flex flex-wrap gap-2 mt-2">
                                        {availablePowerValues.map((powerValue: any, index: number) => (
                                            <div key={index} className="mb-2">
                                                <div
                                                    className="border btn rounded text-center py-2 px-5 bg-secondary text-info"
                                                    onClick={() => handleSelectPowerValue(powerValue)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <div className="fw-semibold">{powerValue}</div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Right side - Selected Values (50%) */}
                                <div className="col-md-12 mt-2">
                                    <h6 className="mb-3">Selected Power Values</h6>
                                    <div className="border rounded p-3" style={{ minHeight: '50px', backgroundColor: '#f8f9fa' }}>
                                        {selectedPowerValues.length === 0 ? (
                                            <div className="text-muted text-center py-4">
                                                No values selected. Click on power values to select them.
                                            </div>
                                        ) : (
                                            <div className="d-flex flex-wrap gap-2">
                                                {selectedPowerValues.map((powerValue: any, index: number) => (
                                                    <div key={index} className="mb-2">
                                                        <div className="border btn-success btn rounded text-center py-2 px-3 d-flex align-items-center gap-2">
                                                            <span className="fw-semibold">{powerValue}</span>
                                                            <span
                                                                className="badge bg-light text-dark rounded-circle"
                                                                onClick={() => handleRemovePowerValue(powerValue)}
                                                                style={{ cursor: 'pointer', fontSize: '12px' }}
                                                            >
                                                                ×
                                                            </span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    {selectedPowerValues.length > 0 && (
                                        <div className="mt-2">
                                            <small className="text-muted">
                                                Selected: {selectedPowerValues.length} value(s)
                                            </small>
                                        </div>
                                    )}
                                </div>
                                <div className="col-md-12 mt-3">
                                    <button
                                        type="button"
                                        className="btn btn-primary float-end"
                                        onClick={() => handleAddPowerGroups(selectedBrand, selectedPowerValues, 0, 100)}
                                    >
                                        Add Selected Group Products
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="card p-5 mt-5">
                <div className="row mb-4">

                    <div className="col-md-12 p-5 mt-4">
                        <AttributeAccordion
                            attributeNames={uniqueAttributes}
                            selectedAttributes={selectedAttributes}
                            onAttributeSelection={handleAttributeSelection}
                            masterData={{}}
                        />
                    </div>
                </div>
            </div>

            {selectedProducts.length > 0 ? (
                <div className="card mt-5 mb-5" style={{ marginTop: "80px" }}>
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <div className="card-title m-0"><h3 className="fw-bolder m-0">Child Models of <b>{selectedProductGroup?.label}</b></h3>
                        </div>

                        <div className="legend-badges">
                            <div className="legend-badge">
                                <div className="badge-dot red"></div>
                                <span className="badge-text">Different value from master model</span>
                            </div>

                        </div>

                        {getSelectedFilteredProductsCount() > 0 && (
                            <button
                                className="btn text-primary font-bold fs-6 btn-sm"
                            // onClick={handleRemoveSelectedProductsWithFilterReset}
                            >

                                Selected ({getSelectedFilteredProductsCount()})
                            </button>
                        )}
                    </div>
                    <div className="card-body p-3">
                        <div style={{ overflowX: "auto", minHeight: "200px", maxHeight: "400px" }}>
                            <table className="table p-4 mb-0">
                                <thead>
                                    <tr>
                                        <th className="fw-bold bg-white" style={{ position: "sticky", top: "0px", width: "50px" }}>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                style={{ width: "18px", height: "18px" }}
                                                checked={areAllProductsSelectedForRemoval()}
                                                onChange={(e) => handleSelectAllForRemoval(e.target.checked)}
                                            />
                                        </th>
                                        <th className="fw-bold bg-white" style={{ whiteSpace: "wrap", minWidth: "250px", position: "sticky", top: "0px" }}>
                                            <div className="mb-3">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Search by product name or model..."
                                                    value={productSearchTerm}
                                                    onChange={(e) => handleProductSearch(e.target.value)}
                                                    style={{
                                                        fontSize: "12px",
                                                        height: "42px",
                                                        border: "1px solid #ddd",
                                                        borderRadius: "5px",
                                                        maxWidth: "280px",

                                                    }}
                                                />
                                            </div>
                                            Select All / Deselect All
                                        </th>
                                        {selectedAttributes.map((attributeName, index) => (
                                            <th className="fw-bold bg-white" key={index}
                                                style={{ whiteSpace: "nowrap", position: "sticky", top: "0px" }}>
                                                <h5 className="fw-bolder mb-3">{attributeName}</h5>
                                                <Multiselect
                                                    options={getUniqueValuesForAttribute(attributeName).map(value => ({
                                                        value,
                                                        displayValue: value === '-' ? 'Blank' : value
                                                    }))}
                                                    displayValue="displayValue"
                                                    placeholder="Filter Values"
                                                    hidePlaceholder={true}
                                                    style={filterMultiSelectStyle}
                                                    showArrow={true}
                                                    customArrow={<CustomArrow />}
                                                    customCloseIcon={<CustomCrossButton />}
                                                    avoidHighlightFirstOption={true}
                                                    onSelect={(selectedList) => handleFilterChange(attributeName, selectedList)}
                                                    onRemove={(selectedList) => handleFilterChange(attributeName, selectedList)}
                                                    selectedValues={attributeFilters[attributeName]?.map(value => ({
                                                        value,
                                                        displayValue: value === '-' ? 'Blank' : value
                                                    })) || []}
                                                />
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {getFilteredProducts().map((product, productIndex) => {
                                        const productId = product.id?.toString() || `product-${productIndex}`;
                                        return (
                                            <tr key={productId}>
                                                <td style={{ width: "60px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        style={{ width: "18px", height: "18px" }}
                                                        checked={isProductSelectedForRemoval(productId)}
                                                        onChange={() => handleProductRemovalSelection(productId)}
                                                    />
                                                    <i
                                                        className="fas fa-edit text-primary ms-2"
                                                        style={{ cursor: "pointer", fontSize: "14px" }}
                                                        title="Edit Product"
                                                        onClick={() => handleEditProduct(productId)}
                                                    ></i>
                                                </td>
                                                <td className="fw-bold" style={{ whiteSpace: "wrap", minWidth: "350px" }}>
                                                    {product.displayName || product.productName || product.name || `Product ${productIndex + 1}`}
                                                </td>
                                                {selectedAttributes.map((attributeName, attrIndex) => {
                                                    // Find the attribute value for this product
                                                    const attributeValue = product.attributes?.find((attr: any) => {
                                                        if (typeof attr === 'string') {
                                                            return attr === attributeName;
                                                        }
                                                        if (typeof attr === 'object' && attr.attributeName) {
                                                            return attr.attributeName === attributeName;
                                                        }
                                                        return false;
                                                    });

                                                    let displayValue = '-';
                                                    if (attributeValue) {
                                                        if (typeof attributeValue === 'string') {
                                                            displayValue = attributeValue;
                                                        } else if (attributeValue.value) {
                                                            displayValue = attributeValue.value;
                                                        }
                                                    }

                                                    // Find the corresponding attribute value in masterModel
                                                    const masterAttribute = masterModel.attributes?.find((attr: any) => {
                                                        if (typeof attr === 'object' && attr.attributeName) {
                                                            return attr.attributeName === attributeName;
                                                        }
                                                        return false;
                                                    }) as { value?: string } | undefined;

                                                    const masterValue = masterAttribute ? masterAttribute.value || '-' : '-';

                                                    // Determine if the values differ
                                                    const hasDifference = masterModel.attributes && masterModel.attributes.length > 0 && displayValue !== masterValue;

                                                    return (
                                                        <td
                                                            key={attrIndex}
                                                            style={{ whiteSpace: "nowrap" }}
                                                            className={hasDifference ? 'text-danger fw-bold' : ''}
                                                        >
                                                            {displayValue}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div className="row mt-5">
                            <div className="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start dt-toolbar">
                                <div className="">

                                    <label className="fs-4">Displaying {selectedProducts.length} of {totalAvailableCount} total available products</label>
                                    {/* <label className="fs-4">Displaying {selectedProducts.length} of {selectedProductGroup?.count} total available products</label> */}
                                </div>
                            </div>
                            <div id="" className="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end">
                                <div className="dt-paging paging_simple_numbers">
                                    {/* {selectedProductGroup?.count > selectedProducts.length && (
​
                                        <button className="btn btn-primary"
                                            onClick={() =>
                                                handleProductFamilyFilter([selectedProductGroup], selectedProducts.length)
                                            }
                                        >
                                            Add More {perPageRecords} Products
                                        </button>
                                    )} */}
                                    {totalAvailableCount > selectedProducts.length &&
                                        (<div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <label
                                                    className="input-group-text"
                                                    style={{ cursor: "pointer" }}
                                                    // onClick={() => handleProductFamilyFilter([selectedProductGroup], selectedProducts.length, perPageRecords)}
                                                    onClick={() => handleAddPowerGroups(selectedBrand, selectedPowerValues as any, selectedProducts.length as any, perPageRecords)}
                                                    htmlFor="inputGroupSelect02"
                                                >
                                                    Add More Product
                                                </label>
                                            </div>
                                            <select
                                                className="form-select form-select-white"
                                                value={perPageRecords}
                                                id="inputGroupSelect02"
                                                onChange={(e) => setPerPageRecords(Number(e.target.value))}
                                            >
                                                <option value="100">100</option>
                                                <option value="200">200</option>
                                                <option value="300">300</option>
                                                <option value="500">500</option>
                                            </select>
                                        </div>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="text-center mt-5 mb-5 text-muted">
                    {selectedProducts.length === 0 ? "No products selected" : "No attributes selected to display"}
                </div>
            )}
        </>
    );
};

export default AddMasterForm